import { Config } from "@amtana/module";
import { z } from "zod";

// S8.07 (ADR-006 §4): a developer or a test forces a flag's value through the environment,
// bypassing every stored override. `FEATURE_FLAGS` names zero or more flags, comma
// separated, each `<key>=on` or `<key>=off` ("lead-scoring=on,analysis-start=off"); parsed
// by `rules/forced-flags.rules.ts`, which this never imports (a contract's own pure parser
// stays in the process half; this file only owns the env variable and its guard).
//
// A forced value is a development and test convenience; production never ships with one,
// the same invariant `refuseInProduction` already holds dev-only secrets and URLs to
// (packages/module's `Config.define`, D020's pattern).

export const featureFlagConfig = Config.define((c) => ({
  forced: c.env("FEATURE_FLAGS", z.string().default(""), {
    refuseInProduction: (value) =>
      value.trim().length > 0
        ? `names a forced flag ("${value.trim()}"); production never starts with a flag forced by the environment`
        : undefined,
  }),
}));
